import { graphql } from "gql";

const INTERNAL_ADMIN_TAG_QUERY = graphql(`
  query InternalAdminTag($id: [ID!]!) {
    internalAdminTag(id: $id) {
      ...InternalAdminTag
    }
  }
`);

export default INTERNAL_ADMIN_TAG_QUERY;
